Hop.loader = {};

Hop.loader.create = function (opts) {
    if (!opts.container) {
        throw new Error('Missing loader container for Hop.loader.create() !');
    }

    const loaderSettings = {
        container: opts.container,
        position: opts.position ? opts.position : 'after',
        size: opts.size ? opts.size : 'small',
        color: opts.color ? opts.color : 'neut',
    };

    function createLoaderInDOM(loaderSettings) {
        const loader = '<div class="loader ' + loaderSettings.position + ' ' + loaderSettings.size + ' ' + loaderSettings.color + '">' + '<span class="sr-only">Loading...</span>' + '</div>';

        if (loaderSettings.position === 'before') {
            loaderSettings.container.prepend(loader);
        } else if (loaderSettings.position === 'after') {
            loaderSettings.container.append(loader);
        }
    }

    createLoaderInDOM(loaderSettings);
};

Hop.loader.destroy = function (loaderContainer) {
    if (!loaderContainer) {
        throw new Error('Missing loader container for Hop.loader.destroy() !');
    }
    loaderContainer.find('.loader').remove();
};
